<template>
  <div>
    <div class="categories-container">
      <h4 class="categories-title">Categories</h4>

      <b-card-group deck class="categories-deck">
        <b-card
          title="Show All"
          :img-src="showAllImg"
          img-alt="Show All"
          img-top
          class="text-center"
          @click="$emit('navigate', 'ExpoShowAllCards'); categorySelected('ShowAll');"
        >
        </b-card>
        <b-card
          title="Education"
          :img-src="educationImg"
          img-alt="Education"
          img-top
          class="text-center"
          @click="$emit('navigate', 'ExpoShowAllCards'); categorySelected('Education');"
        >
        </b-card>
        <b-card
          title="Business"
          :img-src="businessImg"
          img-alt="Business"
          img-top
          class="Essential Oil text-center"
          @click="$emit('navigate', 'ExpoShowAllCards'); categorySelected('Business');"
        >
        </b-card>
        <b-card
          title="Surprise Me"
          :img-src="surpriseMeImg"
          img-alt="Surprise Me"
          img-top
          class="text-center"
          @click="$emit('navigate', 'ExpoShowAllCards'); categorySelected('Surprise');"
        >
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import showAll from "@/assets/images/centre/perks/ShowAll.png";
import business from "@/assets/images/centre/perks/Bussines.png";
import education from "@/assets/images/centre/perks/Education.png";
import surpriseMe from "@/assets/images/centre/perks/SurpriseMe.png";

export default {
  name: "ExpoCategoriesCards",
  data() {
    return {
      showAllImg: showAll,
      businessImg: business,
      educationImg: education,
      surpriseMeImg: surpriseMe,
    }
  },
  methods: {
    categorySelected(category) {
      this.$root.$emit(
        "category",
        category
      );
      this.$router.push({
        name: "Expo",
        query: { category: category },
    }).catch(()=>{});
    },
  },
};
</script>

<style scoped lang="scss">
$light-gray: #e7e7e7;

.categories-title {
  font-weight: 700;
  margin-bottom: 3rem;
}

div.card {
  border: none;
  display: inline-block;
  transition: all .2s ease-in-out;
  &:hover {
    cursor: pointer;
    transform: scale(1.1);
  }
}

.card-img-top {
  border-radius: 50%;
  vertical-align: middle;
  background-color: $light-gray;
  width: 160px;
  height: 160px;
  filter: drop-shadow(0 0.5rem 0.25rem rgba(0, 0, 0, 0.2));
}

h4.card-title {
  font-size: 16px;
}

@media screen and (max-width: 767px) {
  div.card-deck.categories-deck {
    display: flex;

    .card {
      margin-bottom: 0;
    }

    .card-img-top {
      max-width: 100%;
      height: auto;
      padding: 0.3rem;
      background-color: transparent;

    }

    h4.card-title {
      font-size: 10px;
    }
  }
}
</style>
